import React from 'react';
import { SchematicShell, Line } from './SchematicPrimitives';

const IN = 0.0254;
const LEG_HEIGHT = 2 * IN;
const LEG_RADIUS = 0.75 * IN;
const LEG_INSET = 1 * IN;
const LID_THICK = 2 * IN;
const LID_OVERHANG = 0.25 * IN;

export function StorageOttomanSchematic({
  widthMeters: width,
  heightMeters: height,
  depthMeters: depth,
  view = 'front',
  strokeColor,
  strokeWidth,
}) {
  const spanW = view === 'left' || view === 'right' ? depth : width;

  if (view === 'left' || view === 'right') {
    return (
      <SchematicShell
        width={depth}
        height={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      >
        <g
          transform={
            view === 'right'
              ? `scale(-1, 1) translate(${-depth}, 0)`
              : undefined
          }
        >
          <Elevation
            span={depth}
            width={width}
            height={height}
            strokeColor={strokeColor}
            strokeWidth={strokeWidth}
          />
        </g>
      </SchematicShell>
    );
  }

  return (
    <SchematicShell
      width={width}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
    >
      <Elevation
        span={width}
        width={width}
        height={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
    </SchematicShell>
  );
}

function Elevation({ span, width, height, strokeColor, strokeWidth }) {
  const lidW = span + LID_OVERHANG * 2;
  const lidLeft = -LID_OVERHANG;
  const bodyTop = LID_THICK;
  const bodyBottom = height - LEG_HEIGHT;
  const bodyH = bodyBottom - bodyTop;

  return (
    <g>
      {/* Lid */}
      <rect
        x={lidLeft}
        y={0}
        width={lidW}
        height={LID_THICK}
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />

      {/* Body */}
      <rect
        x={0}
        y={bodyTop}
        width={span}
        height={bodyH}
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />

      {/* Center seam on body */}
      <Line
        x1={span / 2}
        y1={bodyTop}
        x2={span / 2}
        y2={bodyBottom}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />

      {/* Legs */}
      {[LEG_INSET + LEG_RADIUS, span - LEG_INSET - LEG_RADIUS].map((cx) => (
        <rect
          key={`leg-${cx}`}
          x={cx - LEG_RADIUS}
          y={bodyBottom}
          width={LEG_RADIUS * 2}
          height={LEG_HEIGHT}
          fill="none"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          vectorEffect="non-scaling-stroke"
        />
      ))}
    </g>
  );
}

StorageOttomanSchematic.supportsSideViews = true;
